import { AnimatePresence } from "framer-motion";
import { useCallback, useState } from "react";

import FilePreview from "@/components/file/Preview";
import { FileCarousel } from "@/components/file/Carousel/FileCarousel";
import { useCoreApp } from "@/contexts/CoreAppContext";
import { BoundingBoxStrategyImpl } from "@utils/annotationStrategies/BoundingBox";
import { FilePreviewProvider } from "@/contexts/FilePreviewProvider";
import { useTestWithMoreFiles } from "@/useTestWithMoreFiles";
import { useCurrentMedia } from "@/store";

// TODO: introduce useFilePreview hook here
const TestFilesVisualAreaContent = () => {
    const { showLabels } = useCoreApp();
    const { testWithMoreFiles, uploadLimitError, clearUploadLimitError } = useTestWithMoreFiles();
    const currentMedia = useCurrentMedia();
    const [isHovered, setIsHovered] = useState(false);

    const onAddMediaItems = useCallback(
        async (files: File[], onFinally?: () => void) => {
            await testWithMoreFiles(files, onFinally);
        },
        [testWithMoreFiles]
    );

    return (
        <AnimatePresence mode="wait">
            <div
                className="visualArea"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                <FilePreviewProvider>
                    <FileCarousel
                        className="h-full w-full"
                        onAddMediaItems={onAddMediaItems}
                        uploadLimitError={uploadLimitError}
                        clearUploadLimitError={clearUploadLimitError}
                        isHovered={isHovered}
                    >
                        <FilePreview
                            key={`file-${currentMedia?.file.id}`}
                            forceHideLabels={!showLabels}
                            strategy={BoundingBoxStrategyImpl}
                        />
                    </FileCarousel>
                </FilePreviewProvider>
            </div>
        </AnimatePresence>
    );
};

export const PreviewVisualAreaContent = () => {
    return <TestFilesVisualAreaContent />;
};
